import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { withRouter, Route, Switch } from 'react-router-dom'

import Headline from 'uiKit/texts/Headline'
import Submenu from 'uiKit/submenu/Submenu'
import Loader from 'uiKit/loaders/loader'
import { HOME_PATH } from 'configs'
import { setBrowserTabTitle } from 'helpers/setBrowserTabTitle'
import { isQcsBotPayload } from 'constants/qcs'
import { hasPermissionForSettingsRoutes } from '../../security'
import { categorizeRoutes } from '../../helpers/routeHelpers'
interface Props {
  activeBot: any
  match: any
  location: any
}

const Settings: React.FC<Props> = ({ activeBot, match, location }) => {
  const pathLink = `${HOME_PATH}/bot/${match.params.botId}/settings`
  const pathRoute = `${HOME_PATH}/bot/:botId/settings/`

  useEffect(() => {
    setBrowserTabTitle(`${activeBot?.name} - Bot Settings`)
  }, [activeBot])

  const settingsRoutesPermission = hasPermissionForSettingsRoutes(match.params.botId, activeBot)
  const currentPath = location.pathname

  // Use helper function to categorize routes and check current path
  // Memoize the result to prevent unnecessary recalculations
  const { submenuRoutes, nonSubmenuRoutes, isNonSubmenuRoute } = useMemo(
    () => categorizeRoutes(settingsRoutesPermission, currentPath),
    [settingsRoutesPermission, currentPath]
  )

  return (
    <>
      {activeBot ? (
        <div>
          {!isNonSubmenuRoute && (
            <>
              <Headline title="Settings" />
              <Submenu
                pathLink={pathLink}
                pathRoute={pathRoute}
                routes={submenuRoutes}
                isQcs={isQcsBotPayload(activeBot)}
              />
            </>
          )}
          <Switch>
            {/* Render only non-submenu routes here, submenu routes are handled by the Submenu component */}
            {nonSubmenuRoutes.map((route: any) => (
              <Route key={route.path} path={`${pathRoute}${route.path}`} exact component={route.component} />
            ))}
          </Switch>
        </div>
      ) : (
        <Loader />
      )}
    </>
  )
}

const mapStateToProps = (state: { activeBot: any }) => ({
  activeBot: state.activeBot,
})

export default withRouter(connect(mapStateToProps)(Settings))
